module.exports = __webpack_public_path__ + "img/fieldPlay1.ce175c26.gif";